<template>
	<div :key="catalogId" class="article-list" ref="contentRef">
		<div class="page-header">
			<breadcrumb />
			<div v-if="canSubmit">
				<el-checkbox v-model="iSubmit" style="margin-right:20px" @change="onISubmitChange" >我提交的内容
				</el-checkbox>
				<el-button type='primary' size='medium' @click="toEditor()">
					提交我的{{currentCatalog.name}}</el-button>
			</div>
		</div>
		<template v-if="catalogOption.showType">
			<article-grid-layout  v-if="catalogOption.showType.code==1" ref="listRef" />
			<article-list-layout style="height:calc(100% - 140px)" v-else ref="listRef" />
		</template>

	</div>

</template>

<script>
	import { catalogOptionsApi } from '@/boot-api/cms'
	import breadcrumb from './breadcrumb.vue'
	import { mapState } from 'vuex'
	import articleListLayout from './article-list-layout.vue'
	import articleGridLayout from './article-grid-layout.vue'
	import articleListMinxin from './article-list-mixin'
	export default {
		components: { breadcrumb, articleListLayout, articleGridLayout },
		mixins: [articleListMinxin],
		data() {
			return {
				canSubmit: false,
				approve: false,
				iSubmit: false,
				/**
				 * @type {{showType:{code:number,description:string}}}
				 */
				catalogOption: {},
				catalogId: null,

			}
		},
		computed: {
			...mapState('cms', ['currentCatalog'])

		},
		watch: {
			currentCatalog(v) {
				this.init(v.id)
			}
		},

		methods: {
			async init(catalogId) {
				this.catalogId = catalogId
				this.catalogOption = await catalogOptionsApi.getOptions({ catalogId }).then(res => res.data)
				if (this.catalogOption) {
					this.approve = this.catalogOption.approve
					this.canSubmit = this.catalogOption.submit
					if(!this.catalogOption.showType) this.catalogOption.showType={code:0}
				}else{
					this.catalogOption={showType:{code:0}}
				}
				this.$nextTick(_ => {			
					this.$refs.listRef.init(catalogId)
				})
			},
			toEditor() {
				
				let url = this.catalogOption.showType && this.catalogOption.showType.code == 1 ? "/cms/content/profile/editor" : "/cms/content/editor"
				url = url + `?catalogId=${this.currentCatalog.id}&from=0`
				this.$router.push(`${url}&approve=${this.approve}`)
			},
			onISubmitChange(v){
				this.$refs.listRef.setISubmit(v)
			}
		},
		async mounted() {
			const catalogId = this.$store.state.cms.currentCatalog.id
			if (catalogId) {
				this.init(catalogId)
			}
		}

	}
</script>

<style lang="scss" scoped>

	.article-list {
		background-color: rgba($color: #fff, $alpha: 0.75);
		width: 850px;
		font-size: 14px;
		padding: 20px 35px 35px 35px;
		border: 1px solid #f2f2f2;
		min-height: calc(100% - 40px);
	}

	.page-header {
		display: flex;
		// align-items: center;
		justify-content: space-between;
	}
</style>


// WEBPACK FOOTER //
// src/views/party-build/article-list.vue